import React from "react";

const OverlayBottom = (props) => {
  return (
    <div
      className={
        "overlay-bottom animated fadeInUp faster pt-5 " +
        (props.overlayOpen ? "fadeInUp" : "fadeOutDown")
      }
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        width: "calc(100% - 250px)",
        height: "100%",
        background: "#f0f3f5",
      }}
    >
      <button
        className="btn w-100 py-2 position-absolute"
        onClick={props.closeOverlay}
        style={{
          top: 0,
          left: 0,
          borderRadius: 0,
          borderBottom: "0",
          boxShadow: "none",
          height: 74,
          zIndex: "999",
        }}
      >
        <i
          className="fa fa-chevron-down fa-2x text-white shadow"
          style={{
            borderRadius: "100%",
            background: "#040ca5",
            width: 50,
            height: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            fontSize: 16,
          }}
        />
      </button>
      <div
        className="p-4 mt-3"
        style={{
          overflowY: "auto",
          height: "100%",
        }}
      >
        {props.children}
      </div>
    </div>
  );
};

export default OverlayBottom;
